import httpService from "./httpService";
import utils from "./utils";

export default {
    findById(id) {
        return httpService.get("communication/" + id, null);
    },

    // Lấy danh sách thông báo
    getListNotifi(usingAdvanceSearch, keyword, form, pageable) {
        let params = utils.merge({
            advanceSearch: usingAdvanceSearch ? true : null,
            keyword
        }, pageable);
        return httpService.post("communication/search", usingAdvanceSearch ? { ...form, title: keyword } : {}, { params });
    },

    // Lấy danh sách thông báo của tôi
    getMyListNotifi(usingAdvanceSearch, keyword, form, pageable) {
        let params = utils.merge({
            advanceSearch: usingAdvanceSearch ? true : null,
            keyword
        }, pageable);
        return httpService.post("communication/search/receiver", usingAdvanceSearch ? { ...form, title: keyword } : {}, { params });
    },

    // Lấy danh sách lịch sử
    getHistoryByNotiId(docId, pageable) {
        let params = { ...pageable, id: docId };
        return httpService.get("communication/search/history", { params });
    },

    // Thêm mới thông báo
    save(form) {
        return httpService.post(`communication`, form);
    },

    // Sửa thông báo
    update(id, form) {
        return httpService.put(`/communication/${id}`, form);
    },

    // Xóa thông báo
    delete(id) {
        return httpService.delete(`communication/${id}`);
    },

    // Xóa nhiều thông báo
    deleteMulti(listNotti) {
        let form = {
            ids: listNotti
        }
        return httpService.post(`communication/delete`, form);
    },
}



// WEBPACK FOOTER //
// ./src/services/notifiService.js